/**
 * **Guestline**
 *
 * @exports bs_229
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  let onPurchaseEvent = null;

  /**
     * @memberOf module:bs_229
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = thn.debounce(() => {
    thn.pageCheck();

    if (thn.data.pageName === 'Rooms and Rates') {
      thn.widgets.price.refresh();
    }
  }, 800);

  /**
   * @memberOf module:bs_229
   * @see {@link prestart}
   *
   * @param {object} ctx - The context object.
   */
  engine.boot = function boot() {
    const dataLayer = window.dataLayer;
    // This engine uses the setting "datalayer_name = customDataLayer".
    // Thus the default thn.dataLayerHelper instance will be created and
    // will read from the "customDataLayer" array NOT from "dataLayer"
    //
    // "customDataLayer" array will be a "mirror" of the actual "dataLayer"
    // with some extra tweeks that are needed to access data that by default is
    // pushed in a non-dataLayer friendly way (it is pushed as Arguments pseudo-array)
    if (dataLayer) {
      window.customDataLayer = window.customDataLayer || [];
      const dataLayerHelper = new thn.DataLayerHelper(dataLayer, function listener(model, event) {
        // All events are pushed as-is to mimic original behaviour
        window.customDataLayer.push(event);
        // Additionally push this specific event as an object
        // so that it gets defined in the dataLayer model as a variable
        // and can be later used in targeting rules
        if (event[1] === 'view_item_list') {
          window.customDataLayer.push({ view_item_list: event[2] });
        }
      }, true);

      thn.shutdown(() => {
        dataLayerHelper.cancel();
      });
    }

    if ([1043355].includes(thn.data.accountUserId)) {
      const undelegate = thn.delegate('click', '.MuiButtonBase-root.MuiButton-root.MuiButton-contained', function () {
        setTimeout(thn.pageCheck({ force: true }), 800);
      });
      thn.shutdown(function () {
        undelegate();
        delete undelegate();
      });
    }

    const containerIframe = document.querySelector('#gldbm-panel');

    if (containerIframe) {
      const refreshPageIframe = thn.debounce(thn.pageCheck, 500);

      thn.observeDom(containerIframe, refreshPageIframe, {
        attributes: true,
        attributeFilter: ['class'],
      });

      thn.shutdown(function () {
        refreshPageIframe.cancel();
        thn.stopObserveDom(containerIframe, refreshPageIframe);
      });
    }

    const containerRoot = document.querySelector('#root');

    if (containerRoot) {
      const refreshPageByAttr = thn.debounce(thn.pageCheck, 500);

      thn.observeDom(containerRoot, refreshPageByAttr, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-testid'],
      });

      thn.shutdown(function () {
        refreshPageByAttr.cancel();
        thn.stopObserveDom(containerRoot, refreshPageByAttr);
      });
    }

    const headerContainer = document.querySelector('header');
    const isBrooksGuestHouseOutsideBE = thn.data.propertyId === 1157779 && window.location.host.includes('brooksguesthouse');

    if (headerContainer && isBrooksGuestHouseOutsideBE) {
      const refreshPageByHeader = thn.debounce(thn.pageCheck, 500);

      thn.observeDom(headerContainer, refreshPageByHeader, {
        childList: true,
        attributes: true,
        subtree: true,
      });

      thn.shutdown(function () {
        refreshPageByHeader.cancel();
        thn.stopObserveDom(headerContainer, refreshPageByHeader);
      });
    }
  };

  /**
     * @memberOf module:bs_229
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const rooms = document.querySelector('.MuiContainer-root section')
      || document.querySelectorAll('.col > div')[1]
      || document.querySelector('[name=results], #results')?.nextElementSibling
      || document.querySelector('[data-testid="availability-results"]');

    if (rooms) {
      let refreshPrice = thn.debounce(() => {
        const roomFiltersApplied = thn.parseNumber(document.querySelector('span.MuiBadge-anchorOriginTopRightRectangle, .MuiBadge-anchorOriginTopRightRectangular')?.textContent);
        if (!document.querySelector('.loading')) { // If the loader is no longer visible
          // Try to refresh the PW data
          ctx.widget.update();
          if (roomFiltersApplied) {
            ctx.widget.hide();
          }
        }
      }, 1000);

      // Rooms observer
      thn.observeDom(rooms, refreshPrice, {
        childList: true,
        subtree: true,
        characterData: false,
      });

      // Stop observing when changing exiting R&R (SPA BE)
      thn.pageUnload(function () {
        // Avoid calling the observer when changing the property using partnerships
        refreshPrice.cancel();
        thn.stopObserveDom(rooms, refreshPrice);
        refreshPrice = null;
      });
    }

    const containerCurrency = document.querySelector('[data-testid="currency-selector"]');

    if (containerCurrency) {
      let refreshPriceByCurrency = thn.debounce(ctx.widget.refresh, 500);

      thn.observeDom(containerCurrency, refreshPriceByCurrency, {
        characterData: true,
      });
      thn.pageUnload(() => {
        refreshPriceByCurrency.cancel();
        thn.stopObserveDom(containerCurrency, refreshPriceByCurrency);
        refreshPriceByCurrency = null;
      });
    }

  };

  /**
   * @memberOf module:bs_229
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/availability/);

    if (validUrl) {

      url.searchParams.set('arrival', '[date_begin]');
      url.searchParams.set('departure', '[date_end]');
      url.searchParams.set('adults', '[adults]');
      url.searchParams.set('children', '[children]');

      ctx.newUrl = url.toString();

      if (ctx.newData.dateBegin && ctx.newData.dateEnd) {
        ctx.newData.dateBegin = (ctx.newData?.dateBegin || ctx.data?.dateBegin)?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1-$2-$3');
        ctx.newData.dateEnd = (ctx.newData?.dateEnd || ctx.data?.dateEnd)?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1-$2-$3');
      }

    } else {
      ctx.newUrl = '';
    }

    return ctx;
  };

  /**
     * @memberOf module:bs_229
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // wait for BE to load to refresh PW to avoid undefined/no rooms
    if (document.querySelector('.loading')) {
      this.logger.debug('Booking engine still loading...');
      return widgetData;
    }

    const activeRoomFilters = thn.parseNumber(document.querySelector('span.MuiBadge-anchorOriginTopRightRectangle, .MuiBadge-anchorOriginTopRightRectangular')?.textContent)
      || thn.parseUrlParameter('filters[rates][]')
      || thn.parseUrlParameter('filters[rates]');

    if (activeRoomFilters) {
      widgetData.priceSpecial = 1;
    }

    // Dates
    const dateBegin = thn.parseUrlParameter('arrival')?.replace(/-/g, '/')
      || document.getElementById('gldbm_startdate')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    const dateEnd = thn.parseUrlParameter('departure')?.replace(/-/g, '/')
      || document.getElementById('gldbm_enddate')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    let nights;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(dateBegin, dateEnd);
    }

    // Guests, Adults & Children
    widgetData.adults = thn.parseNumber(thn.parseUrlParameter('adults')) || 2;
    widgetData.children = thn.parseNumber(thn.parseUrlParameter('children')) || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices & Currency || No Rooms
    const prices = [...document.querySelectorAll('div > span > .price__current, [data-testid="room-rates"] > div > div .price')]
      .filter((priceEl) => !priceEl.closest('[data-testid="rate-payment-type"]'),
      ).map((price) => thn.parseNumber(price.textContent));

    const currencyTextContent = document.querySelector('[data-testid="currency-selector"], span.price')?.textContent
      || document.querySelector('div > span > .price__current')?.textContent;
    const currency = thn.parseCurrency(currencyTextContent);

    // no availability text, currently only in english.
    const noAvailabilityPattern = /no available rooms/;
    // very tricky to really detect no-rooms, get the text element that matches the previous pattern.
    const noAvailability = [...document.querySelectorAll('p.MuiTypography-root, .MuiAlert-message.css-1xsto0d')].filter((el) => el.textContent?.match(noAvailabilityPattern)).length;

    if (prices.length
      && currency
      && nights) {
      widgetData.price = Math.min(...prices) / nights;
      widgetData.currency = currency;
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_229
   * @this thn.widgets.booking
   * @see {@link Booking#observeDom}
   *
   * @param {object} ctx - The context object.
   */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {
    if (onPurchaseEvent) {
      // Already listening, skip ...
      return;
    }

    if (this.isSet()) {
      // Data was already set, skip ...
      return;
    }

    onPurchaseEvent = ({ message }) => {
      if ((message?.[1] === 'purchase' || message?.[1] === ' wihp_purchase') && this.setData().isSet()) {
        this.save();
        thn.bus.detach('dataLayer:push', onPurchaseEvent);
      }
    };

    thn.bus.on('dataLayer:push', onPurchaseEvent, true);
    thn.pageUnload(() => {
      thn.bus.detach('dataLayer:push', onPurchaseEvent);
    });
  };

  /**
     * @memberOf module:bs_229
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    const dataDL = dataLayer.find((item) => item[0] === 'event' && item[1] === 'purchase')?.[2] || dataLayer.find((item) => item[0] === 'event' && item[1] === 'wihp_purchase')?.[2];
    const bookingId = thn.objectGet(dataDL, 'transaction_id');
    const multiroomUsers = [1045832].includes(thn.data.accountUserId);

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    // Get info from the dataLayer
    thn.logger.debug('Saving data from dataLayer');
    const isMultiRoom = thn.objectGet(dataDL, 'items')?.length > 1;

    if (isMultiRoom && multiroomUsers) {
      const widgetDataMulti = thn.objectGet(dataDL, 'items').map((room, index) => ({
        bookingId: `${bookingId}/${index + 1}`,
        dateBegin: (room.checkInDate || room.start_date)?.replace(/-/g, '/'),
        dateEnd: (room.checkOutDate || room.end_date)?.replace(/-/g, '/'),
        price: room.price,
        currency: thn.objectGet(dataDL, 'currency'),
        promocode: room.coupon,
      }));

      return widgetDataMulti;
    }

    widgetData.bookingId = bookingId;
    widgetData.dateBegin = (thn.objectGet(dataDL, 'items')?.[0]?.checkInDate || thn.objectGet(dataDL, 'items')?.[0]?.start_date)?.replace(/-/g, '/');
    widgetData.dateEnd = (thn.objectGet(dataDL, 'items')?.[0]?.checkOutDate || thn.objectGet(dataDL, 'items')?.[0]?.end_date)?.replace(/-/g, '/');
    widgetData.price = thn.parseNumber(thn.objectGet(dataDL, 'value'));
    widgetData.currency = thn.objectGet(dataDL, 'currency');
    widgetData.promocode = thn.objectGet(dataDL, 'items')?.[0]?.coupon;

    return widgetData;
  };

  /**
     * @memberOf module:bs_229
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {
    const promocode = document.querySelector('#promoCode')?.value
      || (((document.querySelector('.promocodeContainer button') || {}).textContent || '').match(/[a-zA-Z0-9]+$/) || []).toString() || '';
    return { promocode };
  };

  return engine;

}

export { factory };
